import styled from "styled-components";
import { Menu } from "Components/Menu";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { getAuth, signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import logoFord from "Assets/Images/BFTPOW.png";
import logoUIL from "Assets/Images/logo-uil-outlined.png";
import { ReactComponent as DaveCampbellSvg } from "Assets/Svgs/dave-campbells-texas-football.svg";

export type HeaderProps = {
  homeScreen?: boolean;
};

export const Header = ({ homeScreen }: HeaderProps) => {
  const { pathname } = useLocation();
  const isAdminView = pathname?.includes("admin");
  const navigate = useNavigate();
  const auth = getAuth();
  const [user] = useAuthState(auth);
  const [open, setOpen] = useState(false);

  const signOutUser = () => {
    signOut(auth)
      .then(() => {
        navigate("/login");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Container homeScreen={homeScreen}>
      <LogoWrapper>
        <Logo src={logoFord} alt="Built Ford Tough: Player Of The Week" />
        {!homeScreen && (
          <>
            <UILLogo src={logoUIL} alt="UIL Logo" />
            <DaveCampbellLogo />
          </>
        )}
      </LogoWrapper>
      {isAdminView ? (
        <Right>
          <UserAvatar onClick={() => setOpen(!open)}>
            {user?.email?.slice(0, 1).toUpperCase() || "F"}
          </UserAvatar>
          {open && (
            <DropdownMenu>
              <Option
                onClick={() => {
                  navigate("/login", { state: { updatePassword: true } });
                }}
              >
                Update password
              </Option>
              <Option
                onClick={() => {
                  signOutUser();
                }}
              >
                Sign Out
              </Option>
            </DropdownMenu>
          )}
        </Right>
      ) : (
        <Menu homeScreen={homeScreen} />
      )}
    </Container>
  );
};

const Container = styled.div<{ homeScreen?: boolean }>`
  width: 100%;
  max-width: 1440px;
  display: flex;
  padding: 10px 40px 20px 10px;
  align-items: center;
  justify-content: space-between;
  position: ${({ homeScreen }) => homeScreen && "absolute"};
  z-index: 10;
`;

const UILLogo = styled.img`
  width: 72px;
  height: auto;
  ${({ theme }) => theme.mediaQueries.mobile} {
    width: 64px;
  }
`;

const DaveCampbellLogo = styled(DaveCampbellSvg)`
  width: 128px;
  height: auto;
  color: #000;
  ${({ theme }) => theme.mediaQueries.mobile} {
    width: 98px;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 44px;

  ${({ theme }) => theme.mediaQueries.mobile} {
    gap: 20px;
  }
`;

const Logo = styled.img<{ isAdmin?: boolean }>`
  width: 100%;
  max-width: 120px;
  object-fit: cover;
  margin: 8px;
  ${({ theme }) => theme.mediaQueries.mobile} {
    margin: 0;
    max-width: 80px;
  }
`;

export const UserAvatar = styled.div`
  height: 47px;
  width: 47px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 25px;
  text-align: center;
  background: #1700f4;
  border-radius: 50%;
  cursor: pointer;
  user-select: none;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
`;

const DropdownMenu = styled.div`
  width: 300px;
  position: absolute;
  top: 105%;
  right: 0;
  z-index: 100;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.16);
  background: #fff;
`;

const Option = styled.div`
  display: block;
  text-decoration: none;
  padding: 8px;
  cursor: pointer;
  user-select: none;
  &:first-child {
    border-bottom: 1px solid #cccccc82;
  }
  &:hover {
    background: #e6e9eb;
  }
`;
